.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}

.col12 {
	grid-column: span 12;
}
.col6 {
	grid-column: span 6;
}
.col3 {
	grid-column: span 3;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: #1a1a1a;
	margin-bottom: 0;
}

.checkboxGroup {
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
	flex-wrap: wrap;
}

.checkboxGroupVertical {
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: flex-start;
}

.checkboxItem {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	user-select: none;
}

.checkboxItem input[type="checkbox"] {
	width: 20px;
	height: 20px;
	cursor: pointer;
	accent-color: #2c7a2c;
	flex-shrink: 0;
}

.checkboxItem label {
	font-size: 0.875rem;
	color: #4a4a4a;
	cursor: pointer;
	margin: 0;
	white-space: nowrap;
}

.error {
	font-size: 0.8rem;
	color: #b91c1c;
	margin-top: -5px;
}

@media (max-width: 640px) {
	.col6 {
		grid-column: span 12;
	}
}
